import clsx from 'clsx';
import type { ComponentPropsWithoutRef } from 'react';

import { getTheme, type Theme } from './Chip.themes';

import type { Colors } from './types/Colors';

export interface ChipProps extends ComponentPropsWithoutRef<'span'> {
  color?: Colors;
  size?: string;
  theme?: Theme;
}

export const Chip = ({
  className,
  color = 'sienna',
  size = 'size-32',
  theme = 'solid',
  children,
  ...attrs
}: ChipProps) => {
  const { thRoot } = getTheme(theme, { color });

  return (
    <span
      {...attrs}
      className={clsx(
        'inline-flex aspect-square shrink-0 items-center justify-center overflow-hidden rounded-full border',
        size,
        thRoot,
        className,
      )}
      data-name="Chip"
    >
      {children}
    </span>
  );
};
